// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
export type ClientProfileFragment = { __typename?: 'ClientProfile', id: string, firstName: string, lastName: string, email?: string | null, dateOfBirth?: Time | null, dateOfDeath?: Time | null, isGrantor: boolean, isPrimary: boolean, displayName: string, legalName: string, middleName?: string | null, suffix?: string | null, preferredName?: string | null, displayNamePattern: Types.ClientProfileDisplayNamePattern, notes?: string | null, isDeceased: boolean, address?: { __typename?: 'Address', id: string, cityName?: string | null, stateCode: string, residesOutsideUnitedStates: boolean } | null };

export type ClientProfileMinimalGrantorRelationshipFragment = { __typename?: 'ClientProfileRelationship', id: string, type: Types.ClientProfileRelationshipType, fromClientProfile: { __typename?: 'ClientProfile', id: string, isGrantor: boolean, isPrimary: boolean }, toClientProfile: { __typename?: 'ClientProfile', id: string, isGrantor: boolean, isPrimary: boolean } };

export type ClientProfileBasicFragment = { __typename?: 'ClientProfile', id: string, displayName: string, legalName: string, firstName: string };

export type RelationshipFragment = { __typename?: 'ClientProfileRelationship', id: string, type: Types.ClientProfileRelationshipType, toClientProfile: { __typename?: 'ClientProfile', id: string } };

export type ClientProfileWithRelationshipsFragment = (
  { __typename?: 'ClientProfile', relationships?: Array<(
    { __typename?: 'ClientProfileRelationship' }
    & RelationshipFragment
  )> | null }
  & ClientProfileFragment
);

export const Operations = {
  Fragment: {
    ClientProfile: 'ClientProfile' as const,
    ClientProfileMinimalGrantorRelationship: 'ClientProfileMinimalGrantorRelationship' as const,
    ClientProfileBasic: 'ClientProfileBasic' as const,
    Relationship: 'Relationship' as const,
    ClientProfileWithRelationships: 'ClientProfileWithRelationships' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const ClientProfileMinimalGrantorRelationshipFragmentDoc = gql`
    fragment ClientProfileMinimalGrantorRelationship on ClientProfileRelationship {
  id
  type
  fromClientProfile {
    id
    isGrantor
    isPrimary
  }
  toClientProfile {
    id
    isGrantor
    isPrimary
  }
}
    `;
export const ClientProfileBasicFragmentDoc = gql`
    fragment ClientProfileBasic on ClientProfile {
  id
  displayName
  legalName
  firstName
}
    `;
export const ClientProfileFragmentDoc = gql`
    fragment ClientProfile on ClientProfile {
  id
  firstName
  lastName
  email
  dateOfBirth
  dateOfDeath
  isGrantor
  isPrimary
  displayName
  legalName
  middleName
  suffix
  preferredName
  displayNamePattern
  notes
  isDeceased
  address {
    id
    cityName
    stateCode
    residesOutsideUnitedStates
  }
}
    `;
export const RelationshipFragmentDoc = gql`
    fragment Relationship on ClientProfileRelationship {
  id
  type
  toClientProfile {
    id
  }
}
    `;
export const ClientProfileWithRelationshipsFragmentDoc = gql`
    fragment ClientProfileWithRelationships on ClientProfile {
  ...ClientProfile
  relationships {
    ...Relationship
  }
}
    ${ClientProfileFragmentDoc}
${RelationshipFragmentDoc}`;